module.exports = __webpack_public_path__ + "a3c2eaea4228f8e223d3e92151137a71.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/violin.png
// module id = 2145
// module chunks = 0